// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"app_wrapper__1cLF6","garland_wrapper":"app_garland_wrapper__3ZbBL","flash-1":"app_flash-1__qMcmy","flash-2":"app_flash-2__2Vb08","flash-3":"app_flash-3__DzADY"};